import progressGr16_202307Module from '../reports/progress-gr1-6-2023-07/index.js';
import progressGr78_202307Module from '../reports/progress-gr7-8-2023-07/index.js';
import provincialGr16_202309Module from '../reports/provincial-gr1-6-2023-09/index.js';
import provincialGr78_202309Module from '../reports/provincial-gr7-8-2023-09/index.js';
import provincialGr912_202202SemModule from '../reports/provincial-gr9-12-2022-02-sem/index.js';

export const REPORT_TYPES = [
  {
    value: "pgrc1to6_2023_07",
    label: "Progress Report",
    subtitle: "Grades 1–6",
    description: "Ontario's standard elementary progress report covering learning skills and subject areas.",
    pdfPreview: progressGr16_202307Module.templateUrl,
    grades: [1, 2, 3, 4, 5, 6],
    disabled: false,
    registryKey: 'pgrc1to6_2023_07',
    freeTrialPath: '/pgrc',
  },
  {
    value: "pgrc7to8_2023_07",
    label: "Progress Report",
    subtitle: "Grades 7–8",
    description: "Ontario's standard junior/intermediate progress report covering learning skills and subject areas.",
    pdfPreview: progressGr78_202307Module.templateUrl,
    grades: [7, 8],
    disabled: false,
    registryKey: 'pgrc7to8_2023_07',
    freeTrialPath: '/pgrc78',
  },
  {
    value: "pvrc1to6_2023_09",
    label: "Provincial Report",
    subtitle: "Grades 1–6",
    description: "Full provincial report card with detailed subject-by-subject letter grades.",
    pdfPreview: provincialGr16_202309Module.templateUrl,
    grades: [1, 2, 3, 4, 5, 6],
    disabled: false,
    registryKey: 'pvrc1to6_2023_09',
    freeTrialPath: '/pvrc',
  },
  {
    value: "pvrc7to8_2023_09",
    label: "Provincial Report",
    subtitle: "Grades 7–8",
    description: "Full provincial report card for Grades 7–8 with History and Geography.",
    pdfPreview: provincialGr78_202309Module.templateUrl,
    grades: [7, 8],
    disabled: false,
    registryKey: 'pvrc7to8_2023_09',
    freeTrialPath: '/pvrc78',
  },
  {
    value: "pvrc9to12_2022_02_sem",
    label: "Provincial Report",
    subtitle: "Grades 9–12",
    description: "Full provincial report card for Grades 9–12 with semester-based course tracking and credit summary.",
    pdfPreview: provincialGr912_202202SemModule.templateUrl,
    grades: [9, 10, 11, 12],
    disabled: false,
    registryKey: 'pvrc9to12_2022_02_sem',
    freeTrialPath: '/pvrc9to12sem',
  }
];

export function getTypeLabelByValue(value) {
  return REPORT_TYPES.find((t) => t.value === value)?.label ?? value;
}
